import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
  Select,
  MenuItem,
  Grid,
  Paper,
  Modal,
  Typography,
  TextField,
  Button,
  Avatar,
} from "@material-ui/core";
import { useUserContext } from "../../../../context/UserContext";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import ImgNotAvailable from "../../../../assets/images/imgNotAvailable.jpg";
import useStyles from "./styles";
import Pal from "../../../../themes/palette";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";

export default function ViewAdmin() {
  const classes = useStyles();
  // context
  const { store } = useUserContext();
  const token = store.data.token;
  ///////////////////////////Buyer Details Start/////////////////////////////////////////////////////
  const [details, setDetails] = useState();
  const [adminDetails, setAdminDetails] = useState({
    name: "",
    email: "",
    birthday: "",
    phoneNumber: "",
    roles: [],
    profilePic: "",
    isAccountActive: false,
  });

  const handleAdminDetails = (input) => (e) => {
    setAdminDetails({ ...adminDetails, [input]: e.target.value });
  };

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  ///////////////Snack Bar ///////////////////////////////////////////////////////////////////

  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const onSelectlogo = (image) => {
    setAdminDetails({ ...adminDetails, profilePic: image });
  };
  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setAdminDetails({ ...adminDetails, profilePic: "" });
    setIsProfilePicRemove(false);
  };

  // image Modal Settings here
  const [modalOpenn, setModelOpenn] = useState(false);
  const handleOpenn = () => {
    setModelOpenn(true);
  };
  const handleClosen = () => {
    setModelOpenn(false);
  };

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  const getAllAdmins = async () => {
    await api
      .get("/superAdmin/admins", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("details are ", res.data.data.superAdmins);
        setDetails(res.data.data.superAdmins);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  const editAdminHandler = (e) => {
    e.preventDefault();

    api
      .patch(
        `/superAdmin/updateAdmin/${adminDetails._id}`,
        {
          ...adminDetails,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const newDetails = details.map((prod) =>
          prod._id === adminDetails._id ? adminDetails : prod
        );
        setDetails(newDetails);
        handleClose();
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Admin Details has been Updated!",
          open: true,
        });
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          type: "error",
          open: true,
        });
      });
  };

  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newComplaintsList = details.map((el) =>
      el._id === id ? { ...el, isAccountBlock: newStatus === "true" } : el
    );

    console.log(newComplaintsList);

    await api
      .patch(
        `/superAdmin/updateAdmin/${id}`,
        { isAccountBlock: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newComplaintsList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          open: true,
        });
      });
  };

  /////////////////Ending /////////////////////////////////////////////////////////////////////

  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
      cellstyle: { whiteSpace: "nowrap" },
    },
    {
      title: "Image",
      field: "profilePic",
      render: ({ profilePic }) => (
        <img
          src={profilePic != null ? profilePic : ImgNotAvailable}
          alt="Profile Pic"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      title: "Name",
      field: "name",
      width: 150,
    },
    {
      title: "Email",
      field: "email",
      width: 150,
    },
    {
      title: "Contact",
      field: "phoneNumber",
      width: 150,
    },
    {
      title: "Status",
      field: "isAccountBlocked",
      align: "center",
      render: ({ isAccountBlock }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            background:
              isAccountBlock === true
                ? "rgba(231, 76, 60, 0.7)"
                : "rgba(112, 224, 0, 0.7)",

            color: "#262626",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              background:
                isAccountBlock === true
                  ? "rgba(231, 76, 60, 0.7)"
                  : "rgba(112, 224, 0, 0.7)",

              width: 15,
              height: 15,
              borderRadius: 8,
              marginRight: 5,
              marginLeft: 5,
            }}
          ></div>
          {isAccountBlock === true ? "Blocked" : "Active"}
        </div>
      ),
    },
    {
      field: "",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="true">Block</MenuItem>
            <MenuItem value="false">Activate</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];

  useEffect(() => {
    getAllAdmins();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={10} lg={12} component={Paper}>
        <MaterialTable
          c
          title="All Admins of Digi-Mart"
          data={details}
          columns={columns}
          actions={[
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setAdminDetails(rowData);
                handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* //////////////////////////////////////////////////Edit Buyer///////////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: 340,
          marginTop: 10,
          width: 700,
          height: 300,
        }}
      >
        <Grid container className={classes.root}>
          <Grid item xs={12} sm={12} md={12} component={Paper}>
            <div className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LibraryAddIcon />
              </Avatar>
              <Typography variant="h5">Add Admin</Typography>
              <form className={classes.form} noValidate>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      autoFocus
                      margin="dense"
                      variant="outlined"
                      autoComplete="fName"
                      required
                      fullWidth
                      label="Full Name"
                      name="fname"
                      value={adminDetails.name}
                      onChange={handleAdminDetails("name")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Email"
                      id="email"
                      name="email"
                      value={adminDetails.email}
                      onChange={handleAdminDetails("email")}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      placeholder="Enter CNIC"
                      label="CNIC Number"
                      name="cnic number"
                      value={adminDetails.CNIC}
                      onChange={handleAdminDetails("CNIC")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      placeholder="Enter Contact"
                      label="Contact Number"
                      name="contact number"
                      value={adminDetails.phoneNumber}
                      onChange={handleAdminDetails("phoneNumber")}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
                </Grid>
                {/*///////////////////////// image upload option /////////////////////////////*/}

                {/*///////////////////////// image upload option /////////////////////////////*/}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Avatar
                    alt="profile photo"
                    src={adminDetails.profilePic}
                    className={classes.avatarInProfileSetting}
                  >
                    {"Pic HERE"}
                  </Avatar>
                  <div style={{ marginTop: 50 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpenn}
                    >
                      <AddAPhotoIcon
                        style={{
                          marginRight: 5,
                          fontSize: 22,
                          marginBottom: 5,
                        }}
                      />
                      Upload
                    </Button>
                    <Button
                      onClick={handlerRemoveProfilePic}
                      style={{ color: "red" }}
                      color="red"
                    >
                      Remove Image
                    </Button>
                  </div>
                </div>
                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editAdminHandler}
                  >
                    Save Changes
                  </Button>
                  <RemoveProfilePic
                    RemoveProfilePic={isProfilePicRemove}
                    setRemoveProfilePic={setIsProfilePicRemove}
                    confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                  />
                </Grid>

                <Snackbar
                  open={open}
                  anchorOrigin={{ vertical, horizontal }}
                  autoHideDuration={3000}
                  onClose={handleCloseSnackBar}
                  key={vertical + horizontal}
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleCloseSnackBar}
                    severity={snackBarstate.type}
                  >
                    {snackBarstate.message}
                  </MuiAlert>
                </Snackbar>
              </form>
            </div>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        open={modalOpenn}
        onClose={handleClosen}
        onBackdropClick={handleClosen}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClosen}
          />
        </div>
      </Modal>
    </Grid>
  );
}
